import { StatusCell } from '../../../components/status/status-cell';

export function FormatPill({ label }: { label: string }) {
  return (
    <StatusCell variant="muted" tone="soft" weight="medium">
      {label}
    </StatusCell>
  );
}
